export const Header = () => {
    return (
        <header
            data-testid="site-header"
            className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10"
        >
            <nav className="max-w-[1400px] mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="brand-logo"
                    className="group flex items-center gap-2 text-white hover:text-[#D91C1C] transition-colors"
                >
                    <img
                        src="https://customer-assets.emergentagent.com/job_mad-drinks/artifacts/35o1dtom_ChatGPT%20Image%2020.%206.%202026%2C%2009_50_18.png"
                        alt="MAD bull logo"
                        className="h-9 w-9 object-contain"
                    />
                    <span className="font-display text-3xl tracking-tighter">
                        MAD
                    </span>
                </a>

                <ul className="flex items-center gap-7 text-xs uppercase tracking-[0.2em] text-white/70">
                    <li>
                        <a
                            data-testid="nav-link-drink"
                            href="#drink"
                            className="hover:text-white transition-colors"
                        >
                            Nápoj
                        </a>
                    </li>
                    <li className="hidden sm:block">
                        <a
                            data-testid="nav-link-details"
                            href="#details"
                            className="hover:text-white transition-colors"
                        >
                            Detaily
                        </a>
                    </li>
                    <li>
                        <a
                            data-testid="nav-link-contact"
                            href="#contact"
                            className="hover:text-white transition-colors"
                        >
                            Kontakt
                        </a>
                    </li>
                </ul>
            </nav>
        </header>
    );
};
